import { css } from '@emotion/react';
import { SectionTitle } from '@/components/general/SectionTitle';
import { ButtonLink } from '@/components/shared/ButtonLink';
import { pagesPath } from '@/lib/pagesPath';
import { getScreen } from '@/styles/media-query';
import { Link, withPrefix } from 'gatsby';


export type DLBannerProps = {
  className?: string;
};

export const DLBanner: React.FC<DLBannerProps> = ({ className }) => {
  return (
    <div
      css={css`
        max-width: 480px;
        width: calc(100% - 40px);
        margin: auto;
        margin-top: 40px;
        
        @media ${getScreen('pc')} {
          max-width: 884px;
          width: 80%;
          margin-top: 80px;
        }
        
        img {
          width: 100%;
        }
      `}
    >
      <Link to="/download/">
        <img 
          css={css`
            display: none;
            @media ${getScreen('pc')} {
              display: block;
            }
          `}
          src={withPrefix('/images/dl-dlbnr-pc.png')} alt="お役立ち資料はこちら"
        /><img 
          css={css`
            @media ${getScreen('pc')} {
              display: none;
            }
          `}
          src={withPrefix('/images/dl-dlbnr.png')} alt="お役立ち資料はこちら"
        />
      </Link>
    </div>
  );
};
